/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconHearts: {
  name: 'hearts';
  data: string;
} = {
  name: 'hearts',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M522.338 220.094c4.026 128.095-196.666 218.084-215.511 288.421C286.236 431.676 94.953 353.764 90.68 220.094c-4.098-128.366 154.147-156.22 216.147-48.84 63.514-110.007 211.548-77.381 215.511 48.84z"/></svg>`,
};
